module.exports = __webpack_public_path__ + "assets/c4cb57a844d1055411ed908c201ac3e3.png";